<script>
import HumanReadableHours from '@/components/HumanReadableHours';

export default {
  props: {
    filter: {
      type: Object,
      default: () => ({}),
    },
    dataService: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      isFetching: false,
      data: {
        totalHours: 0,
        totalHoursFiltered: 0,
        totalWorkers: 0,
        totalDepartments: 0,
      },
    };
  },
  watch: {
    filter () {
      this.fetchData({ silent: true });
    },
  },
  methods: {
    async fetchData ({ silent = false } = {}) {
      this.isFetching = !silent;

      try {
        this.data = await this.dataService(this.filter);
      } catch (error) {
        console.error(error);
      }

      this.isFetching = false;
    },
  },
  created () {
    this.fetchData();
  },
  render () {
    const { $style, data } = this;

    if (this.isFetching) {
      return (
        <div class={$style.wrapper}>
          <u-spinner />
        </div>
      );
    }

    return (
      <div class={$style.wrapper}>
        <div class={$style.indicator}>
          <span class={$style.indicatorValue}>
            <HumanReadableHours hours={data.totalHours} />
          </span>
          <span class={$style.indicatorLabel}>
            за все время
          </span>
          <span class={$style.indicatorNote}>
            {data.totalHours.toFixed(2)}
            ч
          </span>
        </div>
        <div class={$style.indicator}>
          <span class={$style.indicatorValue}>
            <HumanReadableHours hours={data.totalHoursFiltered} />
          </span>
          <span class={$style.indicatorLabel}>
            за указанный период
          </span>
          <span class={$style.indicatorNote}>
            {data.totalHoursFiltered.toFixed(2)}
            ч
          </span>
        </div>
        <div class={$style.indicator}>
          <span class={$style.indicatorValue}>
            {data.totalWorkers}
          </span>
          <span class={$style.indicatorLabel}>
            участников
          </span>
          <span class={$style.indicatorNote}>
            за все время
          </span>
        </div>
        <div class={$style.indicator}>
          <span class={$style.indicatorValue}>
            {data.totalDepartments}
          </span>
          <span class={$style.indicatorLabel}>
            департаментов
          </span>
          <span class={$style.indicatorNote}>
            за все время
          </span>
        </div>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.indicator {
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: 1.5em;
  margin-right: 3em;

  &Value {
    color: $color-primary-darker;
    display: block;
    font-size: 2em;
    font-weight: bold;
    line-height: 1;
    white-space: nowrap;
  }

  &Label {
    display: block;
    line-height: 1.25;
  }

  &Note {
    color: $color-gray-darkest;
    display: block;
    font-size: .75em;
    font-style: italic;
    line-height: 1.25;
  }
}
</style>
